/**
 * LabResultOrderCell.tsx
 *
 * The Order ID cell of the Lab Results list (LabOrdersPage). In its own file
 * so it can be tested: the page cannot be imported by a test (see
 * labOrdersFilters.ts). Access rows add their status badge (plan
 * 2026-10-16-001, U14); Quest and Vibrant rows render as they did inline.
 */
import type { LabResultListItem } from '@/services/lab-orders.service';
import { AccessResultStatusBadge } from '@/pages/patients/labs/AccessResultStatusBadge';

/**
 * Amber flags a Quest result missing its order; an Access result with no order
 * is normal (it was matched by name and birth date), so it takes its own
 * colour, as Vibrant does.
 */
function orderClassName(row: LabResultListItem): string {
  if (row.source === 'vibrant') return 'font-medium text-cyan-700';
  if (row.source === 'access') return 'font-medium text-teal-700';
  if (row.orderFound) return 'text-slate-700';
  return 'font-medium text-amber-700';
}

export function LabResultOrderCell({ row }: { row: LabResultListItem }) {
  return (
    <div className="flex items-center gap-2">
      <span className={orderClassName(row)}>
        {row.orderDisplay || '—'}
      </span>
      {row.source === 'access' && <AccessResultStatusBadge status={row.resultStatus} label={row.orcStatus} />}
    </div>
  );
}
